const fieldsToMatchOn = ['street', 'unit', 'city', 'state', 'postalCode'];
export function addressToMatchString(address) {
    return (Object.keys(address || {})
        .sort()
        // Only include important keys and
        // remove all whitespace to eliminate false positives
        // when comparing addresses.
        .reduce((str, key) => {
        var _a;
        if (fieldsToMatchOn.includes(key) && address[key]) {
            return str + ((_a = address[key]) === null || _a === void 0 ? void 0 : _a.replace(/\s/g, ''));
        }
        return str;
    }, ''));
}
/**
 * Checks if two Addresses are the same
 * @param address1
 * @param address2
 * @returns True if the addresses are the same, false otherwise
 */
export function compareAddresses(address1, address2) {
    return addressToMatchString(address1) === addressToMatchString(address2);
}
/**
 * Returns true if objects shallow equal
 * @param {object} obj1
 * @param {object} obj2
 * @returns {boolean}
 */
export function shallowIsEqual(obj1, obj2) {
    if (obj1 && obj2) {
        return Object.keys(obj1).every((key) => obj1[key] === obj2[key]);
    }
    return false;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYWRkcmVzcy91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLGVBQWUsR0FBRyxDQUFDLFFBQVEsRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxZQUFZLENBQUMsQ0FBQztBQUMxRSxNQUFNLFVBQVUsb0JBQW9CLENBQUMsT0FBc0M7SUFDekUsT0FBTyxDQUNMLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxJQUFJLEVBQUUsQ0FBQztTQUN2QixJQUFJLEVBQUU7UUFDUCxrQ0FBa0M7UUFDbEMscURBQXFEO1FBQ3JELDRCQUE0QjtTQUMzQixNQUFNLENBQUMsQ0FBQyxHQUFHLEVBQUUsR0FBRyxFQUFFLEVBQUU7O1FBQ25CLElBQUksZUFBZSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsSUFBSSxPQUFPLENBQUMsR0FBcUIsQ0FBQyxFQUFFLENBQUM7WUFDcEUsT0FBTyxHQUFHLElBQUcsTUFBQSxPQUFPLENBQUMsR0FBcUIsQ0FBQywwQ0FBRSxPQUFPLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFBLENBQUM7UUFDbEUsQ0FBQztRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUNULENBQUM7QUFDSixDQUFDO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUsZ0JBQWdCLENBQzlCLFFBQXVDLEVBQ3ZDLFFBQXVDO0lBRXZDLE9BQU8sb0JBQW9CLENBQUMsUUFBUSxDQUFDLEtBQUssb0JBQW9CLENBQUMsUUFBUSxDQUFDLENBQUM7QUFDM0UsQ0FBQztBQU9EOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLGNBQWMsQ0FHNUIsSUFBUyxFQUFFLElBQVM7SUFDcEIsSUFBSSxJQUFJLElBQUksSUFBSSxFQUFFLENBQUM7UUFDakIsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUUsSUFBSSxDQUFDLEdBQUcsQ0FBUyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO0lBQzVFLENBQUM7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMifQ==